import { ScreenshotBox } from "fleet/view/device/screenshot";
import { connect } from "react-redux";
import { createPromiseApiAction } from "redux-store/api-sagas";
import { TAKE_SCREEN_SHOT_DEVICE, TAKE_WEBCAM_SNAPSHOT_DEVICE } from "redux-store/devices/actions";
import * as FeatureFlags from 'redux-store/feature-flags/selectors';

function mapStateToProps(state, props) {
  const featureFlags = FeatureFlags.getFeatureFlags(state);

  return {
    featureFlags,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    takeScreenshot: (deviceId) => {
      return createPromiseApiAction(dispatch, TAKE_SCREEN_SHOT_DEVICE, [
        deviceId,
      ]);
    },
    takeWebcamSnapshot: (deviceId) => {
      return createPromiseApiAction(dispatch, TAKE_WEBCAM_SNAPSHOT_DEVICE, [
        deviceId,
      ]);
    }
  };
}

const ConnectedScreenshotBox = connect(mapStateToProps, mapDispatchToProps)(ScreenshotBox);

export { ConnectedScreenshotBox };
